import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';
import { useAuthStore } from '../store/authStore';
import { Home, MessageCircle, BookOpen, LogOut, Settings } from 'lucide-react';

export default function ReaderLayout({ children }) {
  const { user, logout } = useAuthStore();
  const nav = useNavigate();
  const link = ({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${isActive ? 'bg-gold/10 text-gold border border-gold/30' : 'text-ee-text2 hover:text-white hover:bg-ee-card2'}`;
  return (
    <div className="min-h-screen bg-ee-bg text-white flex">
      <aside className="w-64 hidden lg:flex flex-col bg-ee-bg2 border-r border-ee-border min-h-screen sticky top-0">
        <div className="p-4 border-b border-ee-border"><Brand size="sm" /></div>
        <nav className="flex-1 p-3 space-y-1">
          <NavLink to="/dashboard" className={link}><Home size={16} /> Dashboard</NavLink>
          <NavLink to="/chat" className={link}><MessageCircle size={16} /> Chat with EE</NavLink>
          <NavLink to="/ebook" className={link}><BookOpen size={16} /> Read E-Book</NavLink>
          <NavLink to="/onboarding" className={link}><Settings size={16} /> Profile</NavLink>
        </nav>
        <div className="p-3 border-t border-ee-border">
          <div className="px-3 py-2 mb-2">
            <div className="text-xs text-ee-muted">Signed in as</div>
            <div className="text-sm text-white truncate">{user?.name || user?.email}</div>
          </div>
          <button onClick={() => { logout(); nav('/'); }} className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-red-400 hover:bg-red-400/10"><LogOut size={14} /> Sign Out</button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <div className="lg:hidden sticky top-0 z-30 bg-ee-bg/90 backdrop-blur border-b border-ee-border flex items-center justify-between p-3">
          <Brand size="sm" />
          <div className="flex items-center gap-2 text-xs">
            <NavLink to="/dashboard" className={({isActive}) => isActive ? 'text-gold' : 'text-ee-text2'}>Home</NavLink>
            <NavLink to="/chat" className={({isActive}) => isActive ? 'text-gold' : 'text-ee-text2'}>Chat</NavLink>
            <NavLink to="/ebook" className={({isActive}) => isActive ? 'text-gold' : 'text-ee-text2'}>Read</NavLink>
          </div>
        </div>
        {children}
      </main>
    </div>
  );
}
